module.exports = __webpack_public_path__ + "static/media/maxresdefault.7cfcf34f.gif";